module.exports = __webpack_public_path__ + "img/2x.e2a27a2.jpg";